<template>
  <div
    :aria-label="t('common.editBar')"
    role="toolbar"
    class="edit-bar flex flex-gap-1 justify-content-center p-3"
  >
    <div class="edit-bar-buttons flex flex-gap-1">
      <RygenButton
        mode="tertiary"
        :disabled="saving || loading"
        :label="t('common.cancel')"
        juicy
        @click="emit('cancel')"
      />
      <RygenButton
        v-tooltip="{
          disabled: !savingDisabled,
          value: savingDisabledTooltip,
        }"
        mode="primary"
        icon="pi pi-save"
        :disabled="saving || loading || savingDisabled"
        :label="t('common.saveChanges')"
        :loading="saving || loading"
        juicy
        @click="emit('save')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useTooltip } from '@rygen/rygen-ui/composables';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';

const props = defineProps({
  loading: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  saving: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  savingDisabled: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  savingDisabledTooltip: {
    type: String,
    required: false,
    default: () => '',
  },
});
const { loading, saving, savingDisabled, savingDisabledTooltip } =
  toRefs(props);
const emit = defineEmits<{
  (event: 'cancel'): void;
  (event: 'save'): void;
}>();

const vTooltip = useTooltip();
const { t } = useI18n();
</script>
